window.enableTimelineDragScroll = function (element) {
    if (!element || element.dataset.timelineDragScrollEnabled === "true") return;

    element.dataset.timelineDragScrollEnabled = "true";
    let isPanning = false;
    let lastClientX = 0;
    let lastClientY = 0;

    element.addEventListener("pointerdown", function (event) {
        if (event.button !== 0 ||
            event.target.closest("[draggable='true'], .drop-target, button, input, a")) {
            return;
        }

        isPanning = true;
        lastClientX = event.clientX;
        lastClientY = event.clientY;
        element.classList.add("cursor-grabbing");
        element.setPointerCapture(event.pointerId);
        event.preventDefault();
    });

    element.addEventListener("pointermove", function (event) {
        if (!isPanning) return;

        element.scrollLeft -= event.clientX - lastClientX;
        element.scrollTop -= event.clientY - lastClientY;
        lastClientX = event.clientX;
        lastClientY = event.clientY;
    });

    const stopPanning = function (event) {
        if (!isPanning) return;

        isPanning = false;
        element.classList.remove("cursor-grabbing");
        if (element.hasPointerCapture(event.pointerId)) {
            element.releasePointerCapture(event.pointerId);
        }
    };

    element.addEventListener("pointerup", stopPanning);
    element.addEventListener("pointercancel", stopPanning);
};
